// Components
import { useMemo } from 'react';
import { DropdownMenuCard } from 'components/Card';
import { parsedCustomerSignatureSelector } from 'slices/auth.slice';
// Slices
import { reservationTemplatesSelector } from 'slices/reservationTemplate.slice';
import { useAppSelector } from 'slices/store';
import { TEDrawerSection } from '@timeedit/ui-components';
// Types
import type { IProps } from './sections.interface';

const Attributes = ({ timeRule, onChange }: IProps) => {
  const templates = useAppSelector(reservationTemplatesSelector);
  const customerSignature = useAppSelector(parsedCustomerSignatureSelector);

  const templateOptions = useMemo(
    () =>
      templates.map((template) => ({
        key: template.id.toString(),
        label: template.name,
        url: `/${customerSignature}/configuration/reservation-templates?item1=${template.id}`,
      })),
    [templates, customerSignature]
  );

  return (
    <TEDrawerSection label="Attributes">
      <div style={{ maxWidth: 500 }}>
        <DropdownMenuCard
          title="Reservation Templates"
          selectedKeys={(timeRule.templates || []).map(String)}
          options={templateOptions}
          onChange={(value) => {
            onChange({ key: 'templates', value: value.map(Number) });
          }}
          readonly
        />
      </div>
    </TEDrawerSection>
  );
};

export default Attributes;
